import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavBar, Toast, Skeleton, PullRefresh, Button } from 'react-vant';
import { ArrowLeft, Passed, Arrow, LabelO } from '@react-vant/icons';
import { getMyRegistrations } from '../../api/club';
import { useSelector } from 'react-redux';

const MyClubs = () => {
  const navigate = useNavigate();
  const { userInfo } = useSelector(state => state.user);
  const basePath = userInfo?.role === 'parent' || userInfo?.role === 'student' ? '/student/clubs' : '/clubs';
  const [clubs, setClubs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMyClubs();
  }, []);

  const fetchMyClubs = async () => {
    try {
      setLoading(true);
      // 只获取确认成功的社团
      const res = await getMyRegistrations({ status: 'confirmed', page_size: 50 });
      setClubs(res.items || []);
    } catch (error) {
      Toast.fail('获取社团列表失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
      <NavBar 
        title="我的社团" 
        leftText={<ArrowLeft size={20} />} 
        onClickLeft={() => navigate(-1)} 
        fixed 
        placeholder
      />
      
      <PullRefresh onRefresh={fetchMyClubs}>
        {loading ? (
          <div style={{ padding: '20px' }}>
            <Skeleton title row={3} />
            <Skeleton title row={3} style={{ marginTop: 20 }} />
          </div>
        ) : (
          <div style={{ padding: '16px' }}>
            {clubs.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '60px 20px', color: '#94a3b8' }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>🎨</div>
                <div style={{ fontSize: 16 }}>您还没有参加任何社团</div>
                <Button 
                  type="primary" 
                  round 
                  style={{ marginTop: 20, width: 120, background: 'var(--primary-green)', borderColor: 'var(--primary-green)' }}
                  onClick={() => navigate(`${basePath}`)}
                >
                  去选课
                </Button>
              </div>
            ) : (
              clubs.map(item => (
                <div 
                  key={item.id} 
                  style={{ 
                    background: '#fff', 
                    borderRadius: '16px', 
                    padding: '20px',
                    marginBottom: '16px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                  onClick={() => navigate(`${basePath}/space/${item.session_id}/${item.student_id}`)}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                    <div style={{ fontSize: 18, fontWeight: 'bold', color: '#0f172a' }}>
                        {item.club_name}
                    </div>
                    <div style={{ color: '#00b578', fontSize: 12, fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 4 }}>
                        <Passed size={14} /> 已加入
                    </div>
                  </div>
                  
                  <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
                    <div style={{ 
                        width: 80, height: 80, borderRadius: 8, 
                        background: 'linear-gradient(135deg, #00b578 0%, #34d399 100%)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        color: '#fff', fontSize: 32
                    }}>
                        {item.club_name?.[0]}
                    </div>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 4 }}>
                        <div style={{ fontSize: 14, color: '#475569', display: 'flex', alignItems: 'center', gap: 4 }}>
                            <LabelO size={14} /> 指导教师：{item.instructor_name || '待定'}
                        </div>
                        <div style={{ fontSize: 13, color: '#94a3b8' }}>
                            活动地点：{item.venue || '学校'}
                        </div>
                    </div>
                  </div>

                  <div style={{ 
                      borderTop: '1px solid #f1f5f9', 
                      paddingTop: 12, 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center' 
                  }}>
                    <span style={{ fontSize: 12, color: '#94a3b8' }}>点击进入社团空间查看考勤与风采</span>
                    <Arrow color="#cbd5e1" />
                  </div>
                </div>
              ))
            )}
          </div>
        )}
      </PullRefresh>
    </div>
  );
};

export default MyClubs;
